<button
  class="theme-toggle"
  (click)="toggleTheme()"
  [attr.aria-label]="'Switch to ' + (isDarkMode ? 'light' : 'dark') + ' mode'"
  [class.dark]="isDarkMode"
>
      <span class="toggle-track">
        <span class="toggle-icon">
          @if (isDarkMode) {
            <span class="icon">🌙</span>
          } @else {
            <span class="icon">☀️</span>
          }
        </span>
      </span>
  <span class="toggle-text">
        {{ isDarkMode ? 'Dark' : 'Light' }}
      </span>
</button>
